<script setup lang="ts">
import {
  useDeleteOutboxMessagesMutation,
  useOutboxMessagesQuery,
  useResetOutboxMessagesMutation,
} from "@/outbox/api/identityQueries";
import { identityOutboxService } from "@/outbox/api/services";
import OutboxServicePage from "@/outbox/components/OutboxServicePage.vue";

definePage({
  meta: {
    auth: ["Developer.Access"],
  },
});
</script>

<template>
  <OutboxServicePage
    :service="identityOutboxService"
    :collection-query-fn="useOutboxMessagesQuery"
    :use-delete-messages-mutation="useDeleteOutboxMessagesMutation"
    :use-reset-messages-mutation="useResetOutboxMessagesMutation"
  />
</template>
